"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Float = /** @class */ (function () {
    function Float() {
    }
    Float.floatToIntBits = function (f) {
        return f;
    };
    return Float;
}());
exports.default = Float;
//# sourceMappingURL=Float.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@zxing/library/esm5/core/util/Float.js
// module id = 364
// module chunks = 0